module.exports = __webpack_public_path__ + "static/img/7.945b519.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/7.png
// module id = +GaZ
// module chunks = 0